<template>
  <section class="footer">
    <div class="copyright">Copyright &copy;{{currentYear}} bigdataonk8s.com 版权所有
<!--    <div class="copyright">Copyright &copy;{{currentYear}} 珠海市芽乐科技有限公司 版权所有-->
      <div class="copyright-police">

        <img src="/static/images/PSO.png" class="police-img">
        <a class="copyright" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44040202001433">
                      <span style="cursor: pointer;">粤公网安备 44040202001433号</span>
        </a>
        <div class="BeastCoreDivider__vertical__3vxv8__2-33-1"></div>

        <a class="copyright" target="_blank" href="http://beian.miit.gov.cn">
                      <span style="cursor: pointer;">粤ICP备2023032905号-1</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {

    }
  },
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    }
  }

}
</script>

<style scoped>

  .footer {
    background: #eee;
    /*height: 168px;*/
    height: 48px;
    padding: 30px 0px;
    width: 100%;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 16px;
    text-align: center;
  }

  .copyright .copyright-police {
    margin-top: 6px;
  }

  .police-img {
    height: 16px;
    width: 16px;
    margin-right: 3px;
    position: relative;
    top: 2px;
  }

  .copyright-police a {
    color: rgba(0, 0, 0, 0.6);
  }


  .BeastCoreDivider__vertical__3vxv8__2-33-1 {
    border-right: 1px solid #999;
    position: relative;
    margin: 0 8px;
    top: -0.06em;
    display: inline-block;
    vertical-align: middle;
    height: 0.9em;
  }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue